import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Importing the pages and components
import WelcomePage from './components/WelcomePage';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import AddNewStudent from './components/AddNewStudent';
import FeePayment from './components/FeePayment';
import StudentPaymentList from './components/StudentPaymentList';
import MiscellaneousExpenses from './components/MiscellaneousExpenses';
import Certificates from './components/Certificates';
import Coaching from './components/Coaching';
import UserProfile from './components/UserProfile';
import FeePaymentEntry from './components/FeePaymentEntry';
import PrivateRoute from './components/PrivateRoute';
import BankRecords from './components/BankRecords';
import CollectionHistory from './components/CollectionHistory';
import Records from './components/Records';
import OldFeesCollection from './components/OldFeesCollection'; // ✅ NEW
import CoachingHistory from './components/CoachingHistory'; // ✅ NEW
import CoachingFeesSummary from './components/CoachingFeesSummary';
import MeetingReport from './components/MeetingReport';
import TransactionHistory from './components/TransactionHistory';
// Importing CSS files
import './styles/App.css';
import './styles/Dashboard.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<WelcomePage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        <Route path="/home" element={
          <PrivateRoute>
            <HomePage />
          </PrivateRoute>
        } />

        <Route path="/add-new-student" element={
          <PrivateRoute>
            <AddNewStudent />
          </PrivateRoute>
        } />

        <Route path="/fee-payment" element={
          <PrivateRoute>
            <FeePayment />
          </PrivateRoute>
        } />

        <Route path="/fee-payment-entry" element={
          <PrivateRoute>
            <FeePaymentEntry />
          </PrivateRoute>
        } />

        <Route path="/student-payment-list" element={
          <PrivateRoute>
            <StudentPaymentList />
          </PrivateRoute>
        } />

        <Route path="/miscellaneous-expenses" element={
          <PrivateRoute>
            <MiscellaneousExpenses />
          </PrivateRoute>
        } />

        <Route path="/certificates" element={
          <PrivateRoute>
            <Certificates />
          </PrivateRoute>
        } />

        <Route path="/coaching" element={
          <PrivateRoute>
            <Coaching />
          </PrivateRoute>
        } />
<Route path="/coaching-history" element={
  <PrivateRoute>
    <CoachingHistory />
  </PrivateRoute>
} />
<Route path="/coaching-fee-summary" element={
  <PrivateRoute>
    <CoachingFeesSummary />
  </PrivateRoute>
} />

        <Route path="/bank-records" element={
          <PrivateRoute>
            <BankRecords />
          </PrivateRoute>
        } />

        <Route path="/collection-history" element={
          <PrivateRoute>
            <CollectionHistory />
          </PrivateRoute>
        } />

        <Route path="/records" element={
          <PrivateRoute>
            <Records />
          </PrivateRoute>
        } />

        <Route path="/oldfeesstudent" element={    // ✅ NEW ROUTE
          <PrivateRoute>
            <OldFeesCollection />
          </PrivateRoute>
        } />
 <Route path="/meeting-report" element={    // ✅ NEW ROUTE
          <PrivateRoute>
            <MeetingReport />
          </PrivateRoute>
        } />

        <Route path="/transaction-history" element={
          <PrivateRoute>
            <TransactionHistory />
          </PrivateRoute>
        } />

        <Route path="/user-profile" element={
          <PrivateRoute>
            <UserProfile />
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
